import { ErrorResponse, RefreshTokenSuccessResponse } from '../../types/auth'
import { callApi } from '../../utils/api'
import { endpoints } from '../config'

export const getUserDataWithRefreshToken = async (refreshToken: string) => {
  const response = await callApi<RefreshTokenSuccessResponse | ErrorResponse<'Unauthorized'>>({
    path: `${endpoints.refreshToken}?${new URLSearchParams({
      refreshToken
    }).toString()}`
  })

  if (!response.data) {
    return null
  }

  if (!response.isOk && 'status' in response.data && response.data.status === 'Unauthorized') {
    return response.data as ErrorResponse<'Unauthorized'>
  }

  return response.data as RefreshTokenSuccessResponse
}
